import { render, staticRenderFns } from "./DrugsShenHe.vue?vue&type=template&id=3474155c&scoped=true"
import script from "./DrugsShenHe.vue?vue&type=script&lang=js"
export * from "./DrugsShenHe.vue?vue&type=script&lang=js"
import style0 from "./DrugsShenHe.vue?vue&type=style&index=0&id=3474155c&prod&lang=scss&scoped=true"
import style1 from "./DrugsShenHe.vue?vue&type=style&index=1&id=3474155c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3474155c",
  null
  
)

export default component.exports